import React from 'react';
import {Button, Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

import Modal from '../../../../shared/components//Modals/Modal.jsx';

class MessageModal extends Modal {
  static propTypes = {
    actions: PropTypes.array
  };

  static defaultProps = {
    actions: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false
    };

    this.close = () => this.props.closeModal();
  }

  render() {
    const {actions, ...props} = this.props;
    const modalProps = {};

    if (!this.state.loading) {
      modalProps.toggle = this.close;
    }

    return (
      <BootstrapModal {...modalProps} isOpen={props.isOpen}>
        <ModalHeader {...modalProps}>{props.title}</ModalHeader>
        <ModalBody>
          <div className="text-center mb-4">{props.message}</div>
          <div className="d-flex justify-content-center ctas">
            {actions.length ?
              actions.map((button, id) => (
                <Button key={id} color={button.color} onClick={() => button.onClick(modalProps)}>
                  {button.text}
                </Button>
              )) : <Button onClick={modalProps.toggle} color="primary">Fermer</Button>
            }
          </div>
        </ModalBody>
      </BootstrapModal>
    );
  }
}

export default withRouter(MessageModal);